import $ from 'jquery';
import { ensureWbModalInBody } from './common/wb-info-modal';
import { reachWbRegistrationGoal } from './common/iframe-work';

const FOREIGN_EMAIL_DENIED_MESSAGE =
  'В соответствии с Федеральным законом от 31.07.2023 № 406-ФЗ регистрация с использованием иностранных адресов электронной почты невозможна. Пожалуйста, используйте другой адрес почты.';

const PROTON_EMAIL_DENIED_MESSAGE =
  'Регистрация с использованием адресов Proton Mail невозможна. Пожалуйста, используйте другой адрес почты.';

const DENIED_EMAIL_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'bing.com',
  'outlook.com',
  'icloud.com',
];

const PROTON_EMAIL_DOMAINS = [
  'protonmail.com',
  'protonmail.ch',
  'proton.me',
  'pm.me',
];

const isForeignEmailDenied = (email) => {
  const parts = String(email || '').toLowerCase().split('@');
  if (parts.length !== 2) {
    return false;
  }

  return DENIED_EMAIL_DOMAINS.includes(parts[1]);
};

const isProtonEmailDenied = (email) => {
  const parts = String(email || '').toLowerCase().split('@');
  if (parts.length !== 2) {
    return false;
  }

  return PROTON_EMAIL_DOMAINS.includes(parts[1]);
};

const getEmbedEmailDeniedMessage = (email) => {
  if (isForeignEmailDenied(email)) {
    return FOREIGN_EMAIL_DENIED_MESSAGE;
  }
  if (isProtonEmailDenied(email)) {
    return PROTON_EMAIL_DENIED_MESSAGE;
  }

  return null;
};

const cleanEmail = (email) => String(email || '').replace(/\+[^@]*/g, '');

const validateEmail = (email) => {
  if (email.length > 64) {
    return false;
  }
  if (getEmbedEmailDeniedMessage(email)) {
    return false;
  }

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

function initWbCabinetArchiveModal() {
  const listPage = document.querySelector('[data-wb-cabinet-list]');
  const modal = document.getElementById('wb-archive-modal');

  if (!listPage || !modal) {
    return;
  }

  const form = document.getElementById('wb-archive-modal-form');
  const descriptionNode = document.getElementById('wb-archive-modal-description');
  const verifiedEmailInput = document.getElementById('wb-archive-verified-email');
  const listConfig = window.wbCabinetListConfig || {};
  const openButtons = listPage.querySelectorAll('[data-wb-archive-open]');
  const closeTargets = modal.querySelectorAll('[data-wb-archive-close]');

  ensureWbModalInBody(modal);

  const escapeHtml = (value) => {
    const node = document.createElement('div');
    node.textContent = value;
    return node.innerHTML;
  };

  const closeModal = () => {
    modal.classList.add('hidden');
    modal.setAttribute('aria-hidden', 'true');
  };

  const openModal = (button) => {
    const archiveUrl = button.getAttribute('data-archive-url') || '';
    const workTitle = button.getAttribute('data-work-title') || '';
    const workId = button.getAttribute('data-work-id') || '';

    if (!archiveUrl || !form) {
      return;
    }

    ensureWbModalInBody(modal);

    form.setAttribute('action', archiveUrl);

    if (verifiedEmailInput && typeof listConfig.verifiedEmail === 'string') {
      verifiedEmailInput.value = listConfig.verifiedEmail;
    }

    if (listConfig.csrfKey && listConfig.csrfToken) {
      let csrfInput = form.querySelector('input[data-wb-archive-csrf]');
      if (!csrfInput) {
        csrfInput = document.createElement('input');
        csrfInput.type = 'hidden';
        csrfInput.setAttribute('data-wb-archive-csrf', '1');
        form.insertBefore(csrfInput, form.firstChild);
      }
      csrfInput.name = listConfig.csrfKey;
      csrfInput.value = listConfig.csrfToken;
    }

    if (descriptionNode) {
      const title = escapeHtml(workTitle || 'заявка');
      const idPart = workId ? ` (ID ${escapeHtml(workId)})` : '';
      descriptionNode.innerHTML = `Заявка <strong>«${title}»</strong>${idPart} будет удалена вместе с загруженными файлами и комментариями. Действие нельзя отменить.`;
    }

    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', () => openModal(button));
  });

  closeTargets.forEach((target) => {
    target.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.classList.contains('hidden')) {
      closeModal();
    }
  });
}

export default function initWbApplications() {
  initWbCabinetArchiveModal();

  const form = document.getElementById('wb-applications-form');

  if (!form || !window.wbApplicationsConfig) {
    return;
  }

  const config = window.wbApplicationsConfig;
  const embedPrefix = config.embedPrefix || '/wb';
  const checkCodeUrl = config.checkCodeUrl || `${embedPrefix}/check-code`;
  const checkEmailUrl = config.checkEmailUrl || `${embedPrefix}/check-email`;
  const contestHashId = String(config.contestHashId || '').trim();
  const contestId = Number(config.contestId || 0);
  const emailInput = $('#wb-applications-email');
  const submitButton = $('#wb-applications-submit');
  const statusBlock = $('#wb-applications-status');
  const overlay = $('#iframe-work-code-overlay');
  const iframeModal = overlay.closest('.iframe-work-code__block');
  const closeButton = iframeModal.find('.iframe-work-code-block__close');
  const submitCodeButton = iframeModal.find('.iframe-work-code-block__submit');
  const codeInput = iframeModal.find('.iframe-work-code-block__input');
  const hiddenEmail = iframeModal.find('.iframe-work-code-block__hidden-email');
  const incorrectCode = iframeModal.find('.iframe-code__incorrect');
  const codeSended = iframeModal.find('.iframe-code__sended');
  const resendButton = iframeModal.find('.iframe-work-code-block__resend');

  let sendCodeRequest = null;
  let attemptCount = 0;
  const MAX_ATTEMPTS = 5;

  const applicationsListUrl = () => `${embedPrefix}/applications/${encodeURIComponent(contestHashId)}`;

  const setStatus = (message, isError = false) => {
    statusBlock.removeClass('hidden error success');
    if (!message) {
      statusBlock.addClass('hidden');
      statusBlock.text('');
      return;
    }

    statusBlock.text(message);
    statusBlock.addClass(isError ? 'error' : 'success');
  };

  const resetCodeModal = () => {
    attemptCount = 0;
    codeInput.val('');
    codeInput.removeClass('iframe-input__red');
    submitCodeButton.attr('disabled', 'disabled');
    incorrectCode.addClass('hidden');
    codeSended.removeClass('hidden');
    incorrectCode.text('Неверный код');
  };

  const isWbEmbed = document.body.classList.contains('wb-embed');

  const openCodeModal = () => {
    iframeModal.removeClass('hidden');
    if (!isWbEmbed) {
      overlay.fadeIn();
    }
    resetCodeModal();
  };

  const closeCodeModal = () => {
    iframeModal.addClass('hidden');
    if (!isWbEmbed) {
      overlay.fadeOut();
    }
    resetCodeModal();
  };

  const sendNewCode = (email, { resend = false } = {}) => {
    if (sendCodeRequest && !resend) {
      return sendCodeRequest;
    }

    const payload = {
      email,
      contest_hash_id: contestHashId,
      contest_id: contestId,
    };
    if (resend) {
      payload.resend = 1;
    }

    sendCodeRequest = $.ajax({
      type: 'POST',
      url: checkCodeUrl,
      dataType: 'json',
      data: payload,
    }).always(() => {
      sendCodeRequest = null;
    });

    return sendCodeRequest;
  };

  const handleSendCodeResponse = (response, onSuccess) => {
    if (
      response?.status === 'error'
      && (response.message === 'foreign_email_denied' || response.message === 'proton_email_denied')
    ) {
      setStatus(getEmbedEmailDeniedMessage(emailInput.val() || hiddenEmail.val() || '') || 'Email недоступен', true);
      closeCodeModal();
      return;
    }

    if (response?.status === 'error' && response.message === 'mail_failed') {
      setStatus('Не удалось отправить код на указанный email. Попробуйте позже.', true);
      return;
    }

    if (response?.already_confirmed) {
      verifyApplicationsAccess(cleanEmail(emailInput.val() || hiddenEmail.val()));
      return;
    }

    if (response?.status !== 'ok') {
      setStatus('Не удалось отправить код. Попробуйте позже.', true);
      return;
    }

    if (typeof onSuccess === 'function') {
      onSuccess(response);
    }
  };

  const verifyApplicationsAccess = (email) => {
    $.ajax({
      type: 'POST',
      url: checkEmailUrl,
      dataType: 'json',
      data: {
        email,
        code: '',
        context: 'applications',
        contest_id: contestId,
        contest_hash_id: contestHashId,
      },
      success(response) {
        if (response?.status === 'success' && response.message === true) {
          if (typeof window.__showWbStepLoader === 'function') {
            window.__showWbStepLoader();
          }
          const nextUrl = response.redirect_url || response.applications_list_url || applicationsListUrl();
          reachWbRegistrationGoal(() => {
            window.location.href = nextUrl;
          });
          return;
        }
      },
    });
  };

  const proceedAfterCodeRequest = (response, email) => {
    handleSendCodeResponse(response, () => {
      setStatus('Код отправлен на почту', false);
      openCodeModal();
    });
  };

  const submitEmail = (e) => {
    e.preventDefault();

    const email = cleanEmail(emailInput.val());

    if (!contestHashId) {
      setStatus('Конкурс не определён', true);
      return;
    }

    const deniedMessage = getEmbedEmailDeniedMessage(email);
    if (deniedMessage) {
      setStatus(deniedMessage, true);
      return;
    }

    if (!validateEmail(email)) {
      setStatus('Введите корректный email адрес', true);
      return;
    }

    submitButton.prop('disabled', true);
    setStatus('Отправка кода…', false);
    hiddenEmail.val(email);

    sendNewCode(email)
      .then((response) => {
        proceedAfterCodeRequest(response, email);
      })
      .fail(() => {
        setStatus('Не удалось отправить код. Попробуйте позже.', true);
      })
      .always(() => {
        submitButton.prop('disabled', false);
      });
  };

  submitButton.on('click', submitEmail);
  form.addEventListener('submit', submitEmail);

  resendButton.on('click', (e) => {
    e.preventDefault();
    const email = cleanEmail(emailInput.val() || hiddenEmail.val());

    if (!validateEmail(email)) {
      setStatus('Введите корректный email адрес', true);
      return;
    }

    resendButton.prop('disabled', true);

    sendNewCode(email, { resend: true })
      .then((response) => {
        handleSendCodeResponse(response, () => {
          incorrectCode.text('Новый код отправлен на вашу почту');
          incorrectCode.removeClass('hidden');
          codeSended.addClass('hidden');
          attemptCount = 0;
        });
      })
      .fail(() => {
        setStatus('Не удалось отправить код. Попробуйте позже.', true);
      })
      .always(() => {
        resendButton.prop('disabled', false);
      });
  });

  closeButton.on('click', (e) => {
    e.preventDefault();
    closeCodeModal();
  });

  overlay.on('click', () => {
    closeCodeModal();
  });

  codeInput.on('input', function () {
    this.value = String(this.value || '').replace(/\D/g, '').slice(0, 6);
    codeInput.removeClass('iframe-input__red');
    incorrectCode.addClass('hidden');
    if (this.value.length === 6) {
      submitCodeButton.removeAttr('disabled');
    } else {
      submitCodeButton.attr('disabled', 'disabled');
    }
  });

  submitCodeButton.on('click', (e) => {
    e.preventDefault();

    const code = String(codeInput.val() || '').replace(/\D/g, '').slice(0, 6);
    const email = cleanEmail(emailInput.val() || hiddenEmail.val());

    if (code.length !== 6 || !validateEmail(email) || !contestHashId) {
      return;
    }

    submitCodeButton.prop('disabled', true);

    $.ajax({
      type: 'POST',
      url: checkEmailUrl,
      dataType: 'json',
      data: {
        email,
        code,
        context: 'applications',
        contest_id: contestId,
        contest_hash_id: contestHashId,
      },
      success(response) {
        if (
          response?.status === 'error'
          && (response.message === 'foreign_email_denied' || response.message === 'proton_email_denied')
        ) {
          setStatus(getEmbedEmailDeniedMessage(email) || 'Email недоступен', true);
          closeCodeModal();
          return;
        }

        if (response?.status === 'success' && response.message === true) {
          if (typeof window.__showWbStepLoader === 'function') {
            window.__showWbStepLoader();
          }
          const nextUrl = response.redirect_url || response.applications_list_url || applicationsListUrl();
          reachWbRegistrationGoal(() => {
            window.location.href = nextUrl;
          });
          return;
        }

        attemptCount += 1;
        codeInput.addClass('iframe-input__red');
        incorrectCode.removeClass('hidden');

        if (attemptCount >= MAX_ATTEMPTS) {
          incorrectCode.text('Превышен лимит попыток. Новый код отправлен на вашу почту.');
          sendNewCode(email, { resend: true }).then((response) => {
            handleSendCodeResponse(response, resetCodeModal);
          });
        } else {
          incorrectCode.text(`Неверный код (осталось попыток: ${MAX_ATTEMPTS - attemptCount})`);
        }
      },
      error() {
        setStatus('Ошибка сети. Попробуйте позже.', true);
      },
      complete() {
        submitCodeButton.prop('disabled', false);
      },
    });
  });
}
